import { render, staticRenderFns } from "./PluginOpenAI.vue?vue&type=template&id=4a902a50&scoped=true"
import script from "./PluginOpenAI.vue?vue&type=script&lang=js"
export * from "./PluginOpenAI.vue?vue&type=script&lang=js"
import style0 from "./PluginOpenAI.vue?vue&type=style&index=0&id=4a902a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a902a50",
  null
  
)

export default component.exports